// extracted by mini-css-extract-plugin
export default {"newsDetails":"newsdetails_newsDetails__QN-yP"};